import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';

if (environment.production) {
  enableProdMode();
}

//Will navigate the user to SCP website if there is a redirectSCP object in local storage
if (localStorage.getItem("redirectSCP")) {
  let object = JSON.parse(localStorage.getItem("redirectSCP")),
    dateString = object.timestamp,
    now = new Date().getTime();
  //if (now > dateString) {
  //  localStorage.removeItem('redirectSCP');
  //} else if (now < dateString) {
    //setTimeout(() => {
    const domain = window.location.hostname;
    if ( domain.includes("localhost") ||  domain.includes("dev")) {
    //if (environment.serviceBaseUrl.includes("localhost") || environment.serviceBaseUrl.includes("dev")) {
      window.location.href = "https://dev-secure.citadel.co.za";
    } else if ( domain.includes("staging")){
    //} else if (environment.serviceBaseUrl.includes("staging")) {
      window.location.href = "https://staging-secure.citadel.co.za";
    } else {
      window.location.href = "https://secure.citadel.co.za";
    }
    //},10000); 
  //}
} else {
  // Remove service worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      //returns installed service workers
      if (registrations.length) {
        for (let registration of registrations) {
          registration.unregister();
        }
      }
    });
  }
  const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

  if (!environment.production) {
    if (module['hot']) {
      hmrBootstrap(module, bootstrap);
    } else {
      console.error('HMR is not enabled for webpack-dev-server!');
      console.log('Are you using the --hmr flag for ng serve?');
    }
  } else {
    bootstrap().catch(err => {
      console.log(err)
    });
  }
}



